const socialImages = (name, url, width, height) => (url ? [{ name, url, width, height }] : undefined);

/**
 * Page meta (title, description, keywords, schema.org data, social images) of a Storyblok story,
 * shaped as props for `Page`.
 *
 * @param {{ content: object }} story
 * @returns {{ title: string, description: string, keywords: string[], schema: object,
 *   facebookImages: Array<object> | undefined, twitterImages: Array<object> | undefined }}
 */
const storyPageMeta = (story) => {
  const { metatags, keywords, linkImage } = story.content;
  const { title = '', description = '' } = metatags || {};

  return {
    title,
    description,
    keywords: keywords ? keywords.split(',').map((kw) => kw.trim()) : [],
    schema: {
      '@context': 'http://schema.org',
      '@type': 'WebPage',
      name: title,
      description,
    },
    facebookImages: socialImages('facebook', linkImage?.filename, 1200, 630),
    twitterImages: socialImages('twitter', linkImage?.filename, 600, 314),
  };
};

export default storyPageMeta;
